import { render } from "./005-Overview.vue?vue&type=template&id=e6d7c7d0"
import script from "./005-Overview.vue?vue&type=script&lang=js"
export * from "./005-Overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__